import { Outlet, useLocation } from "react-router-dom";
import styles from "./Home.module.css";
import Navbar from "shared/components/Navbar/Navbar";
import PersonalDetails from "features/personal-details";
import Collaborate from "features/collaborate";
import { PRIMARY_NAV_ITEMS } from "shared/constants/navigation";

const Home = () => {
  const location = useLocation();

  return (
    <div className={styles.content}>
      <Navbar navItems={PRIMARY_NAV_ITEMS} />
      <div className={styles.row}>
        <div className={styles.personalDetails}>
          <PersonalDetails />
        </div>

        <div className={styles.detailsContainer}>
          <div className={styles.outletWrapper}>
            <Outlet />
          </div>
          {location.pathname !== "/contact" && <Collaborate />}
        </div>
      </div>
    </div>
  );
};

export default Home;
